import { render, staticRenderFns } from "./userPortalDetail.vue?vue&type=template&id=6e455a4d&scoped=true"
import script from "./userPortalDetail.vue?vue&type=script&lang=js"
export * from "./userPortalDetail.vue?vue&type=script&lang=js"
import style0 from "./userPortalDetail.vue?vue&type=style&index=0&id=6e455a4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e455a4d",
  null
  
)

export default component.exports